import { Component, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'awardee-modal',
	templateUrl: './awardee-modal.component.html',
	styleUrls: ['./awardee-modal.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class AwardeeModalComponent {

	@Input() type: string;
	@Input() year: any;
	@Input() individualDescription: boolean = false;
	@Input() isVisible: boolean = false;
	@Input() isVerticalAlignment: boolean = false;
	@Input() showAwardTitle: boolean = false;
	@Input() contentAlignBottom: boolean = false;
	@Output() onVisibleChange = new EventEmitter<boolean>();

	constructor() {}

	closeModal() {
		document.body.removeAttribute('style');
		this.isVisible = false;
		this.onVisibleChange.emit(this.isVisible);
	}

	showAwardeeModal() {
		document.body.style.overflow = 'hidden';
		this.isVisible = true;
	}

	ngOnDestroy() {
		this.closeModal();
	}
	
	ngOnInit() {}
}